import BigodToken from "../../images/aboutToken1.webp";
import chipLeft from "../../images/chipRight1.svg";
import chipRight from "../../images/chipLeft1.svg";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect, useState } from "react";
import coin from "../../images/coin.svg";
import blockchain from "../../images/blockChain.svg";
import blockchain1 from "../../images/blockchain1.svg";
import supply from "../../images/supply.svg";
import goldBricks from "../../images/goldBricks.svg";
import locker from "../../images/locker.svg"
import bigodToken1 from "../../images/bigodToken.webp";

const BingoldInfo = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  
  const leftData = [
    { title: "Ticker", value: "BIGOD", img: coin },
    {
      title: "Blockchain",
      value: "Binance Smart Chain (BEP-20)",
      img: blockchain,
    },
    {
      title: "Security",
      value: "Binance Smart Chain",
      img: blockchain1,
    },
  ];
  const rightData = [
    {
      title: "Total Supply",
      value: "2,500,000 tokens",
      img: supply,
    },
    {
      title: "Backed by",
      value: "250g gold per token",
      img: goldBricks,
    },
    {
      title: "Utility",
      value: "Trading, Staking, Payments, Hedging",
      img: locker,
    },
  ];

  return (
    <div className="text-white flex flex-col  items-center ">
      <h2 className="text-[#15BFFD] md:text-3xl text-2xl font-semibold mb-2">
       About BINGOLD (BIGOD)
      </h2>
      <p className="text-[17px] font-medium text-center mb-2">Gold Backed Token Ownership for the Global Economy</p>
      <p className="text-center w-full max-w-4xl   text-[17px] font-medium ">
       BINGOLD (BIGOD) is a revolutionary <b>gold-backed token</b> and <b>real-world asset (RWA)</b>. Each token is pegged to <b>250 grams of fully audited, </b> securely stored and verifiable through <b >GoldOnBlockchain</b> technology.</p>
       <p className="text-center w-full max-w-4xl   text-[17px] font-medium mt-3">
        Built on the robust <b>BNB Chain (BEP-20)</b> , BIGOD enables <b>real asset tokenization</b> , bridging physical gold with decentralized finance <b>(Gold DeFi Token)</b>. With only <b> 2.5 million tokens </b> available, BIGOD is designed for <b>secure crypto investment, value preservation</b>, and <b>long-term digital wealth transfer</b> .
      </p>
      <div
        className="md:max-w-[1120px] sm:max-w-[1000px] max-w-[600px] w-full flex sm:flex-row md:flex-row flex-col justify-center items-center bg-cover bg-center bg-no-repeat mt-20"
        style={{
          background: "radial-gradient(circle, #044572 0%, #000000 45%)",
        }}
      >
        <div className="flex flex-col gap-16 ">
          {leftData.map((item, index) => (
            <div
              className="relative "
              key={index}
              data-aos={isMobile ? "fade-up" : "fade-right"}
              data-aos-delay={index * 300}
            >
              <img src={item.img} alt="" className="h-[40px] absolute -top-10 left-5" />
              <img src={chipLeft} alt="" />
              <div className="absolute inset-0 flex flex-col items-center justify-center px-4 text-center">

                <p className="md:text-[17px] sm:text-sm text-base text-white font-medium text-center mb-1">
                  {item.title}
                </p>
                <p className="md:text-[17px] sm:text-xs text-base font-medium text-center text-[#15BFFD]">{item.value}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="md:block sm:block hidden">
          <img src={BigodToken} className="w-[700px] max-w-full" />
        </div>
        <div className="md:hidden sm:hidden block mt-7 mb-7">
          <img src={bigodToken1} className="w-[260px] max-w-full animate-spin-reverse-slow z-20" />
        </div>
        <div className="flex flex-col gap-16">
          {rightData.map((item, index) => (
            <div
              className="relative"
              key={index}
              data-aos={isMobile ? "fade-up" : "fade-left"}
              data-aos-delay={index * 300}
            >
              <img src={item.img} alt="" className="h-[40px] absolute -top-10 left-5" />
              <img src={chipRight} alt="" />
              <div className="absolute inset-0 flex flex-col items-center justify-center px-4 text-center">
                <p className="md:text-lg sm:text-sm text-base text-white font-medium text-center mb-1">
                  {item.title}
                </p>
                <p className="md:text-lg sm:text-xs text-base font-medium text-center text-[#15BFFD]">{item.value}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>


  );
};

export default BingoldInfo;
